

export class BlogSuggest {
    ajaxCall(query: string) {
        if (query.length > 2) {
            let htmlElement : HTMLElement = document.getElementById("js-head-search-suggestion");
            htmlElement.setAttribute("style", "visibility:hidden");

            let promise: Promise<string> = fetch('/cms/blog/suggest?query=' + query)
                .then(response => {
                    return response.text();
                });

            promise.then(function (suggestResult) {
                if (suggestResult.length > 0) {
                    let targetElement : HTMLElement = document.getElementById("js-blog-search-suggestion");
                    htmlElement.setAttribute("style", "visibility:visible; display: block;");
                    targetElement.innerHTML = '';
                    targetElement.insertAdjacentHTML('afterbegin',suggestResult);
                }
            });
        }
    }


    init() {
        let DELAY_MS = 500;
        let that = this;
        document.addEventListener("DOMContentLoaded", function () {
            let htmlElement  = document.getElementById("header-blogsearch-query");
            htmlElement.addEventListener("keydown", function (e) {
                let suggestResult = document.getElementsByClassName(".head-search-suggestion")[0];
                if (e.code == "13") {
                    let innerElement = document.getElementById("header-blogsearch-query");
                    if (innerElement.textContent.length == 0) {
                        e.preventDefault();
                        suggestResult.setAttribute("visibility", "hidden");
                    }
                }
            });

            htmlElement.addEventListener("input", function () {
                //document.getElementById("form-header-search-spellchecked").remove();
                let query = (htmlElement as HTMLInputElement).value;
                let timeout = setTimeout(function () {
                    that.ajaxCall(query);
                }, DELAY_MS);
            });
        });
    }
}

let blogSuggest = new BlogSuggest();
blogSuggest.init();